import mock from './mock';
import './patient-form';

// forwards the matched request over network
mock.onAny().passThrough();
